import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

export const useBannerImages = () => {
  const [banners, setBanners] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        setLoading(true);

        // Fetch banners from the banners table
        const { data: bannersData, error: bannersError } = await supabase
          .from('banners')
          .select('*')
          .not('img', 'is', null) // Only get banners with images
          .order('created_at', { ascending: false });

        if (bannersError) {
          console.error('Error fetching banners:', bannersError);
          throw bannersError;
        }

        if (bannersData && bannersData.length > 0) {
          // Filter banners that have img URLs
          const validBanners = bannersData.filter(banner => banner.img && banner.img.trim() !== '');

          console.log('Found banners from database:', validBanners);
          setBanners(validBanners);
          // Keep images array for backward compatibility
          setImages(validBanners.map(banner => banner.img));
        } else {
          console.log('No banners found in database');
          // Fallback to bucket if no banners in table
          const { data: bucketData, error: bucketError } = await supabase.storage
            .from('banner')
            .list('', {
              limit: 100,
              offset: 0,
            });

          if (!bucketError && bucketData && bucketData.length > 0) {
            const imageUrls = bucketData.map((file) => {
              const { data: { publicUrl } } = supabase.storage
                .from('banner')
                .getPublicUrl(file.name);
              return publicUrl;
            });
            setImages(imageUrls);
            // Create banner objects from bucket files
            setBanners(imageUrls.map((url, index) => ({
              id: `bucket_${index}`,
              img: url,
              duration: '4000', // Default 4 seconds
              name: `Banner ${index + 1}`
            })));
          }
        }
      } catch (err) {
        console.error('Error fetching banners:', err);
        setError(err.message);
        // Use default fallback
        const defaultBanners = [
          {
            id: 'default_1',
            img: 'https://lxprwdplyftigaemzaua.supabase.co/storage/v1/object/public/banner/banner.jpeg',
            duration: '4000',
            name: 'Default Banner 1'
          },
          {
            id: 'default_2',
            img: 'https://lxprwdplyftigaemzaua.supabase.co/storage/v1/object/public/banner/bk.jpeg',
            duration: '4000',
            name: 'Default Banner 2'
          }
        ];
        setBanners(defaultBanners);
        setImages(defaultBanners.map(b => b.img));
      } finally {
        setLoading(false);
      }
    };

    fetchBannerImages();
  }, []);

  return { banners, images, loading, error };
};
